export default {"src":"/_next/static/media/VendorArtworkStatuses.352ac19b.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};